var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:_vm.cssClass,attrs:{"outlined":_vm.outline,"depressed":"","rounded":"","color":_vm.color},on:{"click":_vm.scrollTo}},'v-btn',_vm.linkProps(_vm.url),false),[_vm._t("default",function(){return [_vm._v("Lees meer")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }